import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';

@Component({
  selector: 'ui-form-range',
  imports: [],
  templateUrl: './form-range.component.html',
  styleUrl: './form-range.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormRangeComponent {
  value = model<number>(0);
  min = input<number>(0);
  max = input<number>(100);
  step = input<number>(1);
  dataCy = input<string>('');

  protected onInput(raw: string): void {
    const parsed = Number(raw);
    if (Number.isNaN(parsed)) {
      return;
    }
    this.value.set(this.clamp(parsed));
  }

  private clamp(value: number): number {
    return Math.min(this.max(), Math.max(this.min(), value));
  }
}
